const TaskContent = [
  {
    taskId: 1,
    name: 'Hello, world! 2',
    description: 'Cetak "Hello, world!"',
    content: `Cetak "Hello, world!" ke konsol`,
    testCase: [
      { input: [], output: ["Hello, world!"] }
    ]
  },
  {
    taskId: 2,
    name: 'Faktorisasi Prima',
    description: 'Jabarkan seluruh faktor prima dari sebuah bilangan',
    content: `
      Terimalah sebuah angka dari pengguna dan cetaklah faktorisasi primanya dimulai dari angka terkecil.<br>
      Apabila terdapat faktor yang memiliki pangkat, maka tulislah dengan format <code>x^y</code>. Cetak seluruh faktor
      ke bawah (tanpa tanda kali).<br><br>
      
      <b>Contoh</b>:
      <br>Apabila angka masukan adalah 24, maka akan dicetak seperti ini:<br>
      <code>
        2^3<br>
        3
      </code><br><br>
      
      Apabila angka masukan adalah 5040, maka akan tercetak seperti ini:<br>
      <code>
        2^4<br>
        3^2<br>
        5<br>
        7
      </code><br><br>
      Untuk angka yang berpangkat, gunakan teks untuk menyambungkan angka dengan pangkatnya. Untuk angka yang tidak berpangkat, tetap cetaklah sebagai angka.
    `,
    testCase: [
      { input: [0], output: [] },
      { input: [1], output: [] },
      { input: [12], output: ["2^2", 3] },
      { input: [36], output: ["2^2", "3^2"] },
      { input: [74], output: [2, 37] },
      { input: [108], output: ["2^2", "3^3"] },
      { input: [211], output: [211] },
      { input: [613], output: [613] },
      { input: [925], output: ["5^2", 37] },
      { input: [990], output: [2, "3^2", 5, 11] },
      { input: [999], output: ["3^3", 37] },
      { input: [5040], output: ["2^4", "3^2", 5, 7] },
      { input: [5476], output: ["2^2", "37^2"] },
      { input: [19600], output: ["2^4", "5^2", "7^2"] },
      { input: [3], output: [3] },
    ]
  },
  {
    taskId: 3,
    name: 'Soal Gampang',
    description: 'Klik uji kode',
    content: `Klik uji kode untuk menang.`,
    toolbox: ``,
    testCase: [
      { input: [], output: [] }
    ]
  },
  {
    taskId: 4,
    name: 'Lorem Ipsum',
    description: 'Klik uji kode',
    content: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque molestie dui viverra lacus mattis tristique. Aenean tristique sodales quam, ut viverra mauris sollicitudin sed. Mauris pharetra urna sed rhoncus vulputate. Fusce tempor ante ac tempus volutpat. Cras iaculis porttitor sapien vitae tincidunt. In feugiat odio velit, vel facilisis nibh sagittis ac. Nunc ut auctor sapien, non fringilla felis. Pellentesque vestibulum lectus vitae nisi condimentum bibendum. Curabitur in porttitor mauris, at scelerisque metus. Sed magna ex, ultricies a gravida sed, congue et turpis.<br><br>

    Integer ut venenatis arcu, in pretium sem. Integer suscipit lorem eu tortor iaculis, quis tristique massa feugiat. Mauris faucibus rutrum purus, ultrices lobortis odio consequat eget. Cras finibus velit bibendum mauris venenatis, at faucibus arcu efficitur. Proin ac odio neque. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Aenean eget dictum lectus. Praesent sit amet enim nec ante dignissim vulputate. Quisque feugiat tellus egestas, egestas est quis, placerat ex. Maecenas rutrum gravida blandit. Suspendisse ac mattis arcu. Aliquam vitae lectus justo. Aenean quis aliquet neque. Donec at metus eget purus commodo tristique a vel neque.`,

    toolbox: ``,
    testCase: [
      { input: [], output: [] }
    ]
  },
  {
    taskId: 5,
    name: 'Lorem Ipsum',
    description: 'Klik uji kode',
    content: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque molestie dui viverra lacus mattis tristique. Aenean tristique sodales quam, ut viverra mauris sollicitudin sed. Mauris pharetra urna sed rhoncus vulputate. Fusce tempor ante ac tempus volutpat. Cras iaculis porttitor sapien vitae tincidunt. In feugiat odio velit, vel facilisis nibh sagittis ac. Nunc ut auctor sapien, non fringilla felis. Pellentesque vestibulum lectus vitae nisi condimentum bibendum. Curabitur in porttitor mauris, at scelerisque metus. Sed magna ex, ultricies a gravida sed, congue et turpis.<br><br>

    Integer ut venenatis arcu, in pretium sem. Integer suscipit lorem eu tortor iaculis, quis tristique massa feugiat. Mauris faucibus rutrum purus, ultrices lobortis odio consequat eget. Cras finibus velit bibendum mauris venenatis, at faucibus arcu efficitur. Proin ac odio neque. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Aenean eget dictum lectus. Praesent sit amet enim nec ante dignissim vulputate. Quisque feugiat tellus egestas, egestas est quis, placerat ex. Maecenas rutrum gravida blandit. Suspendisse ac mattis arcu. Aliquam vitae lectus justo. Aenean quis aliquet neque. Donec at metus eget purus commodo tristique a vel neque.`,

    toolbox: ``,
    testCase: [
      { input: [], output: [] }
    ]
  },
  {
    taskId: 6,
    name: 'Lorem Ipsum',
    description: 'Klik uji kode',
    content: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque molestie dui viverra lacus mattis tristique. Aenean tristique sodales quam, ut viverra mauris sollicitudin sed. Mauris pharetra urna sed rhoncus vulputate. Fusce tempor ante ac tempus volutpat. Cras iaculis porttitor sapien vitae tincidunt. In feugiat odio velit, vel facilisis nibh sagittis ac. Nunc ut auctor sapien, non fringilla felis. Pellentesque vestibulum lectus vitae nisi condimentum bibendum. Curabitur in porttitor mauris, at scelerisque metus. Sed magna ex, ultricies a gravida sed, congue et turpis.<br><br>

    Integer ut venenatis arcu, in pretium sem. Integer suscipit lorem eu tortor iaculis, quis tristique massa feugiat. Mauris faucibus rutrum purus, ultrices lobortis odio consequat eget. Cras finibus velit bibendum mauris venenatis, at faucibus arcu efficitur. Proin ac odio neque. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Aenean eget dictum lectus. Praesent sit amet enim nec ante dignissim vulputate. Quisque feugiat tellus egestas, egestas est quis, placerat ex. Maecenas rutrum gravida blandit. Suspendisse ac mattis arcu. Aliquam vitae lectus justo. Aenean quis aliquet neque. Donec at metus eget purus commodo tristique a vel neque.`,

    toolbox: ``,
    testCase: [
      { input: [], output: [] }
    ]
  },
  {
    taskId: 7,
    name: 'Lorem Ipsum',
    description: 'Klik uji kode',
    content: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque molestie dui viverra lacus mattis tristique. Aenean tristique sodales quam, ut viverra mauris sollicitudin sed. Mauris pharetra urna sed rhoncus vulputate. Fusce tempor ante ac tempus volutpat. Cras iaculis porttitor sapien vitae tincidunt. In feugiat odio velit, vel facilisis nibh sagittis ac. Nunc ut auctor sapien, non fringilla felis. Pellentesque vestibulum lectus vitae nisi condimentum bibendum. Curabitur in porttitor mauris, at scelerisque metus. Sed magna ex, ultricies a gravida sed, congue et turpis.<br><br>

    Integer ut venenatis arcu, in pretium sem. Integer suscipit lorem eu tortor iaculis, quis tristique massa feugiat. Mauris faucibus rutrum purus, ultrices lobortis odio consequat eget. Cras finibus velit bibendum mauris venenatis, at faucibus arcu efficitur. Proin ac odio neque. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Aenean eget dictum lectus. Praesent sit amet enim nec ante dignissim vulputate. Quisque feugiat tellus egestas, egestas est quis, placerat ex. Maecenas rutrum gravida blandit. Suspendisse ac mattis arcu. Aliquam vitae lectus justo. Aenean quis aliquet neque. Donec at metus eget purus commodo tristique a vel neque.`,

    toolbox: ``,
    testCase: [
      { input: [], output: [] }
    ]
  },
  {
    taskId: 8,
    name: 'Lorem Ipsum',
    description: 'Klik uji kode',
    content: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque molestie dui viverra lacus mattis tristique. Aenean tristique sodales quam, ut viverra mauris sollicitudin sed. Mauris pharetra urna sed rhoncus vulputate. Fusce tempor ante ac tempus volutpat. Cras iaculis porttitor sapien vitae tincidunt. In feugiat odio velit, vel facilisis nibh sagittis ac. Nunc ut auctor sapien, non fringilla felis. Pellentesque vestibulum lectus vitae nisi condimentum bibendum. Curabitur in porttitor mauris, at scelerisque metus. Sed magna ex, ultricies a gravida sed, congue et turpis.<br><br>

    Integer ut venenatis arcu, in pretium sem. Integer suscipit lorem eu tortor iaculis, quis tristique massa feugiat. Mauris faucibus rutrum purus, ultrices lobortis odio consequat eget. Cras finibus velit bibendum mauris venenatis, at faucibus arcu efficitur. Proin ac odio neque. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Aenean eget dictum lectus. Praesent sit amet enim nec ante dignissim vulputate. Quisque feugiat tellus egestas, egestas est quis, placerat ex. Maecenas rutrum gravida blandit. Suspendisse ac mattis arcu. Aliquam vitae lectus justo. Aenean quis aliquet neque. Donec at metus eget purus commodo tristique a vel neque.`,

    toolbox: ``,
    testCase: [
      { input: [], output: [] }
    ]
  },
  {
    taskId: 9,
    name: 'Lorem Ipsum',
    description: 'Klik uji kode',
    content: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque molestie dui viverra lacus mattis tristique. Aenean tristique sodales quam, ut viverra mauris sollicitudin sed. Mauris pharetra urna sed rhoncus vulputate. Fusce tempor ante ac tempus volutpat. Cras iaculis porttitor sapien vitae tincidunt. In feugiat odio velit, vel facilisis nibh sagittis ac. Nunc ut auctor sapien, non fringilla felis. Pellentesque vestibulum lectus vitae nisi condimentum bibendum. Curabitur in porttitor mauris, at scelerisque metus. Sed magna ex, ultricies a gravida sed, congue et turpis.<br><br>

    Integer ut venenatis arcu, in pretium sem. Integer suscipit lorem eu tortor iaculis, quis tristique massa feugiat. Mauris faucibus rutrum purus, ultrices lobortis odio consequat eget. Cras finibus velit bibendum mauris venenatis, at faucibus arcu efficitur. Proin ac odio neque. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Aenean eget dictum lectus. Praesent sit amet enim nec ante dignissim vulputate. Quisque feugiat tellus egestas, egestas est quis, placerat ex. Maecenas rutrum gravida blandit. Suspendisse ac mattis arcu. Aliquam vitae lectus justo. Aenean quis aliquet neque. Donec at metus eget purus commodo tristique a vel neque.`,

    toolbox: ``,
    testCase: [
      { input: [], output: [] }
    ]
  },
  {
    taskId: 10,
    name: 'Lorem Ipsum',
    description: 'Klik uji kode',
    content: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque molestie dui viverra lacus mattis tristique. Aenean tristique sodales quam, ut viverra mauris sollicitudin sed. Mauris pharetra urna sed rhoncus vulputate. Fusce tempor ante ac tempus volutpat. Cras iaculis porttitor sapien vitae tincidunt. In feugiat odio velit, vel facilisis nibh sagittis ac. Nunc ut auctor sapien, non fringilla felis. Pellentesque vestibulum lectus vitae nisi condimentum bibendum. Curabitur in porttitor mauris, at scelerisque metus. Sed magna ex, ultricies a gravida sed, congue et turpis.<br><br>

    Integer ut venenatis arcu, in pretium sem. Integer suscipit lorem eu tortor iaculis, quis tristique massa feugiat. Mauris faucibus rutrum purus, ultrices lobortis odio consequat eget. Cras finibus velit bibendum mauris venenatis, at faucibus arcu efficitur. Proin ac odio neque. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Aenean eget dictum lectus. Praesent sit amet enim nec ante dignissim vulputate. Quisque feugiat tellus egestas, egestas est quis, placerat ex. Maecenas rutrum gravida blandit. Suspendisse ac mattis arcu. Aliquam vitae lectus justo. Aenean quis aliquet neque. Donec at metus eget purus commodo tristique a vel neque.`,

    toolbox: ``,
    testCase: [
      { input: [], output: [] }
    ]
  },
]

export default TaskContent
